import { BasicLink } from "@components/typography"
import { FlexBox } from "@components/wrapper"
import React from "react"
import { Job } from "@interfaces/career"
import clsx from "clsx"
import dayjs from "dayjs"
import { BiMap } from "react-icons/bi"

interface CareerCardProps {
  career: Job
  customWidth?: string
}

export const CareerCard: React.FC<CareerCardProps> = ({ career, customWidth }: CareerCardProps) => {
  return (
    <BasicLink
      href={`/career/${career.category_id}/${career.career_position_id}`}
      className={clsx("bg-primary-grey px-6 sm:pt-10 sm:pb-8 rounded", customWidth, "py-8")}
    >
      <FlexBox align="center" className={clsx("sm:gap-2.5 mb-5", "gap-2")}>
        <div className="bg-green rounded-full sm:wh-2.5 wh-2" />
        <div className="sm:text-sm text-xxs font-semibold">{career.category?.category_name}</div>
      </FlexBox>

      <div className={clsx("text-dark-green sm:mb-8 font-semibold", "mb-6")}>
        {career.career_position?.position_name}
      </div>

      <FlexBox align="center" className={clsx("sm:gap-2.5 sm:mb-60px", "gap-2 mb-[50px]")}>
        <BiMap className="sm:text-lg text-sm" />
        <FlexBox className={clsx("sm:text-sm gap-2.5", "text-xs")} align="center">
          <div>{career.job_system}</div>
          <div>-</div>
          <div>{career.job_type}</div>
        </FlexBox>
      </FlexBox>

      <div className="text-xs font-semibold text-green">
        Diposting {dayjs(career.created_at).locale("id").fromNow(true)} yang lalu
      </div>
    </BasicLink>
  )
}
